import $ from 'jquery'
const $doc = $(document)

function showMatrixImages(event) {
    console.log('showMatrixImages function called');
    
    // Get all matrix images from the page
    const matrixImages = document.querySelectorAll('.hero__matrix__image');
    console.log('Found matrix images:', matrixImages.length);
    
    // Convert NodeList to array and get their src attributes
    const imageSources = Array.from(matrixImages)
        .filter(img => img.dataset.src?.trim())
        .map(img => {
            console.log('Image src:', img.dataset.src);
            return img.dataset.src;
        });
    
    // Shuffle the array and take first 4 images
    for (let i = imageSources.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [imageSources[i], imageSources[j]] = [imageSources[j], imageSources[i]];
    }
    const shuffledImages = imageSources.slice(0, 4);
    console.log('Shuffled images:', shuffledImages);
    
    // Get the SVG container
    const svgContainer = document.querySelector('.hero__matrix__svg svg');
    console.log('SVG container found:', !!svgContainer);
    if (!svgContainer) {
        console.error('SVG container not found!');
        return;
    }


    // Create defs element if it doesn't exist
    let defs = svgContainer.querySelector('defs');
    if (!defs) {
        defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
        svgContainer.insertBefore(defs, svgContainer.firstChild);
    }
    
    // Create a wrapper for each image
    for (let i = 0; i < 4; i++) {
        console.log('Processing image', i + 1);
        const personElement = document.getElementById(`appendPerson${i + 1}`);
        const careersPerson = document.getElementById(`careersPerson${i + 1}`);
        console.log(`Looking for appendPerson${i + 1}:`, personElement);
        console.log(`Looking for careersPerson${i + 1}:`, careersPerson);
        
        if (!personElement || !careersPerson) {
            console.error(`Required elements not found for index ${i + 1}`);
            continue;
        }
        
        if (!shuffledImages[i]) {
            console.error(`No image source available for appendPerson${i + 1}`);
            continue;
        }
        
        // Get the dimensions and position from careersPerson
        const pathBox = careersPerson.getBBox();
        console.log(`Path dimensions for careersPerson${i + 1}:`, pathBox);
        
        // Add a larger scale factor to ensure complete coverage
        const scale = 1.15; // 15% larger
        const scaledWidth = pathBox.width * scale;
        const scaledHeight = pathBox.height * scale;
        const offsetX = (scaledWidth - pathBox.width) / 2;
        const offsetY = (scaledHeight - pathBox.height) / 2;
        
        console.log(`Scaled dimensions for image ${i + 1}:`, {
            original: { width: pathBox.width, height: pathBox.height },
            scaled: { width: scaledWidth, height: scaledHeight },
            offset: { x: offsetX, y: offsetY }
        });
        
        // Create a clipPath element
        const clipPathId = `clip-${i + 1}`;
        const clipPath = document.createElementNS("http://www.w3.org/2000/svg", "clipPath");
        clipPath.setAttribute("id", clipPathId);
        
        // Create a circle for rounded corners
        const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        const radius = Math.max(pathBox.width, pathBox.height) / 2;
        circle.setAttribute("cx", pathBox.x + pathBox.width / 2);
        circle.setAttribute("cy", pathBox.y + pathBox.height / 2);
        circle.setAttribute("r", radius);
        
        clipPath.appendChild(circle);
        defs.appendChild(clipPath);
        
        // Create an SVG image element
        const image = document.createElementNS("http://www.w3.org/2000/svg", "image");
        image.setAttribute("href", shuffledImages[i]);
        image.setAttribute("x", pathBox.x - offsetX);
        image.setAttribute("y", pathBox.y - offsetY);
        image.setAttribute("width", scaledWidth);
        image.setAttribute("height", scaledHeight);
        image.setAttribute("preserveAspectRatio", "xMidYMid slice");
        image.setAttribute("clip-path", `url(#${clipPathId})`);
        
        // Add the image directly to the person element
        personElement.appendChild(image);
        console.log(`Image added to appendPerson${i + 1}`);
        
        // Make the original path visible with stroke (after adding the image)
        personElement.setAttribute('fill', 'transparent');
        personElement.setAttribute('stroke', 'white');
        personElement.setAttribute('stroke-width', '2');
    }
}

export default function initHeroMatrix() {
    console.log('initHeroMatrix called');
    $doc.ready(showMatrixImages);
}
